<template lang="pug">
  div(v-if="itemData && itemData.length > 0", style="margin-left: 16px;")
    div(class="customer-reject-title", @click="showDialog = true") ดูสาเหตุ
    el-dialog(custom-class="feedback-dialog", :visible.sync="showDialog")
        div(v-for="(item, index) in itemData")
          .p-feedback-dialog(class="bold") สาเหตุที่ลูกค้าปฏิเสธ
          .p-feedback-dialog
            span.space {{ item.content }}&nbsp;
            span (ปฏิเสธเมื่อ {{ item.createdAt | time2human }})
          hr(v-if="index+1 !== itemData.length")
</template>

<style>
  .customer-reject-title {
    cursor: pointer;
    margin-top: 5px;
    font-size: 13px;
    text-align: left;
    text-decoration: underline;
    color: #FF577F;
  }
  .feedback-dialog {
    width: 35%;
    height: 60%;
    overflow-y: auto;
    white-space: initial;
    border-radius: 8px;
  }
  .bold {
    font-family: 'Sukhumvit-Bold';
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 24px;
    color: #303133;
  }
  .el-dialog__body {
    padding: 60px 50px 30px 50px;
  }
  hr {
    margin: 24px 0;
  }
  .p-feedback-dialog {
    font-size: 18px;
  }
  .space {
    margin-right: 8px;
  }

</style>

<script>
import moment from 'moment'

export default {
  name: 'MatchingCustomerFeedback',
  props: {
    itemData: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      showDialog: false,
    }
  },
  filters: {
    time2human (value) {
      return moment(value).format('DD/MM/YYYY')
    },
  },
}
</script>
